import {Component, Inject} from '@angular/core';
import { APP_CONFIG, AppConfig } from './app.config';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import {NavController, Platform} from '@ionic/angular';
import {Constants} from "../models/contants.models";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {MyEvent} from "../services/myevent.services";
import {OneSignal} from "@ionic-native/onesignal/ngx";
import firebase from "firebase";



@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  rtlSide = 'left';
  selectedIndex: any;
  appPages: any;
  defaultLang = '';
  constructor(@Inject(APP_CONFIG) public config: AppConfig,
              private platform: Platform,private router: Router,
              private splashScreen: SplashScreen, private statusBar: StatusBar,
              private translate: TranslateService, private myEvent: MyEvent,
              private navCtrl: NavController, private oneSignal: OneSignal,
              ) {
    this.initializeApp();
    this.navCtrl.navigateRoot('sign-in');
    this.myEvent.getLanguageObservable().subscribe(value => {
      this.navCtrl.navigateRoot(['./']);

      this.globalize(value);
      console.log(value);
    });
  }
  ngOnInit() {
    const path = window.location.pathname.split('folder/')[1];
    if (path !== undefined) {
      this.selectedIndex = this.appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
    }
  }
  initializeApp() {
    this.platform.ready().then(() => {
      //this.statusBar.styleDefault();
      this.statusBar.backgroundColorByHexString('#b0206f');
      this.splashScreen.hide();
      this.defaultLang = window.localStorage.getItem(Constants.KEY_DEFAULT_LANGUAGE);
      console.log(this.defaultLang);
      if (this.defaultLang == null){
        this.defaultLang = 'en';
        window.localStorage.setItem(Constants.KEY_DEFAULT_LANGUAGE, this.defaultLang);
      }
      this.platform.backButton.subscribeWithPriority(-1, () => {
        const url = this.router.url;
        if (url === '/my-tabs/home' || url === '/my-tabs/bookings' ||
          url === '/my-tabs/chat-list' || url === '/my-tabs/notifications') {
          this.router.navigate(['./my-tabs']);
        }
        if (url === '/sign-in' || url === '/register') {
          this.router.navigate(['./sign-in']);
        }
      });
      this.globalize(this.defaultLang);
      this.setupPush();

    });
  }
  setupPush() {
    if(this.platform.is('ios') || this.platform.is('android'))
    {
      // I recommend to put these into your environment.ts
      this.oneSignal.getPermissionSubscriptionState()
        .then(e => {
          console.log(e.permissionStatus.status);
        });
      this.oneSignal.startInit('f58dcd93-7f45-4ff4-ba2e-987988c237b1', '1079272509952');
      this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.Notification);
      // Notifcation was received in general
      this.oneSignal.handleNotificationReceived().subscribe(data => {
        console.log(data);
        const msg = data.payload.body;
        const title = data.payload.title;
        const additionalData = data.payload.additionalData;
        data.payload.smallIcon = 'drawable-hdpi-icon'
        data.payload.smallIconAccentColor = 'b0206f'
        //this.showAlert(title, msg, additionalData.task);
        let numberNotifications = JSON.parse(
          window.localStorage.getItem(Constants.KeyNotifications));
        if (numberNotifications == null) {
          numberNotifications = 0;
        }
        numberNotifications = numberNotifications + 1;
        window.localStorage.setItem(Constants.KeyNotifications, numberNotifications);

      });

      // Notification was really clicked/opened
      this.oneSignal.handleNotificationOpened().subscribe(data => {
        // Just a note that the data is a different place here!
        const additionalData = data.notification.payload.additionalData;
      });
      this.oneSignal.endInit();
      this.oneSignal.getIds().then(identity => {
        console.log(identity.pushToken);
        console.log(identity.userId);
        window.localStorage.setItem(Constants.KeyOneSignal, identity.userId);
      }).catch(err => {
        console.log(err);
      });
      this.oneSignal.clearOneSignalNotifications();
    }
  }
  globalize(languagePriority) {
    this.translate.setDefaultLang('en');
    const defaultLangCode = this.config.availableLanguages[0].code;
    this.translate.use(languagePriority && languagePriority.length ? languagePriority : defaultLangCode);
    this.setDirectionAccordingly(languagePriority && languagePriority.length ? languagePriority : defaultLangCode);
  }

  setDirectionAccordingly(lang: string) {
    switch (lang) {
      case 'ar': {
        this.rtlSide = 'rtl';
        break;
      }
      default: {
        this.rtlSide = 'ltr';
        break;
      }
    }
  }
}
